import styled, { css } from 'styled-components'
import { IText } from '@wirtualna-polska/n2cr-ds'

import { breakpoints } from '@ads/front-core/constants/breakpoints'

export const HeaderTitle = styled.span<{ bold?: boolean }>`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 45px;
  line-height: 70px;
  color: #262a44;
  font-weight: 300;
  letter-spacing: 0.2px;

  ${p =>
    p.bold &&
    `
    font-weight: bold;
  `}

  @media (max-width: ${breakpoints.MOBILE}) {
    font-size: 26px;
    line-height: 39px;
  }
`

export const Title = styled.span<{ bold?: boolean; color?: IText['color'] }>`
  ${p => css`
    font-family: 'Poppins', sans-serif;
    font-size: 36px;
    line-height: 54px;
    color: ${p.color ? p.theme.colors[p.color] : '#262a44'};
    font-weight: ${p.bold ? '700' : '300'};
    letter-spacing: 0.2px;
    white-space: pre-line;

    @media (max-width: ${breakpoints.MOBILE}) {
      font-size: 26px;
      line-height: 39px;
    }
  `}
`

export const SubTitle = styled.span<{ bold?: boolean }>`
  ${p => css`
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    line-height: 36px;
    color: #262a44;
    font-weight: ${p.bold ? '700' : '300'};
    letter-spacing: 0.2px;
  `}
`

export const Text = styled.span<{
  bold?: boolean
  color?: IText['color']
}>`
  ${p => css`
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    line-height: 27px;
    color: ${p.color ? p.theme.colors[p.color] : '#262a44'};
    font-weight: ${p.bold ? '700' : '300'};
    white-space: pre-wrap;
  `}
`

export const ButtonStyled = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;

  border: 0px solid transparent;
  color: ${p => p.theme.colors.inverted100};
  background-color: #ec1c24;

  font-size: 18px;
  border-radius: 50px;
  cursor: pointer;
  height: 55px;

  font-family: 'Poppins', sans-serif;
  font-weight: bold;
  text-decoration: none;
  padding: 14px 36px;
  white-space: nowrap;

  &:hover {
    background-color: #ec1c24;
    color: white;
  }
`

export const ButtonDemoAccount = styled.button<{ color?: IText['color'] }>`
  ${ButtonStyled}

  ${p => css`
    border: 2px solid #e6e8ed;
    color: ${p.theme.colors[p.color]};
    background-color: transparent;

    &:hover {
      color: ${p.theme.colors[p.color]};
      background-color: transparent;
    }
  `}
`
